module.exports = __webpack_public_path__ + "img/HE_logo.30e6db7e.svg";